<script lang="ts" setup>
import { useHead } from '@unhead/vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { Constants } from '@/utilities/constants.ts';
import { client } from '@/api/client.gen.ts';

client.setConfig({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  credentials: 'include',
});

const route = useRoute();
const { locale } = useI18n();

useHead({
  htmlAttrs: {
    lang: () => locale.value,
    ...(import.meta.env.SSR ? { 'data-ssr': route.path } : {}),
  },
  link: () => {
    return [{ rel: 'preload', href: locale.value == 'en-CA' ? `${Constants.CdnBaseUrl}/public/projectnewhome.svg` : `${Constants.CdnBaseUrl}/public/projethabitation.svg`, as: 'image' }];
  },
});
</script>

<template>
  <DefaultLayout />
</template>

<style lang="css" scoped></style>
